"use client";

import { motion } from "motion/react";

interface AnimatedFlowLineProps {
  isHovered: boolean;
}

// Clean bezier curve path matching the smooth wavy line
const LINE_PATH = "M 0,55 C 100,85 170,85 270,50 C 390,5 510,0 600,15 C 640,22 655,32 660,38";

export default function AnimatedFlowLine({ isHovered }: AnimatedFlowLineProps) {
  return (
    <div className="w-full relative -ml-8">
      {/* Background static line */}
      <svg
        width="660"
        height="90"
        viewBox="0 0 660 90"
        fill="none"
        className="w-full"
        style={{ overflow: "visible" }}
      >
        <path
          d={LINE_PATH}
          stroke="#B4B4B4"
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
        />
      </svg>

      {/* Animated overlay line */}
      <svg
        width="660"
        height="90"
        viewBox="0 0 660 90"
        fill="none"
        className="w-full absolute top-0 left-0"
        style={{ overflow: "visible" }}
      >
        <motion.path
          d={LINE_PATH}
          stroke="#0095FF"
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: isHovered ? 1 : 0 }}
          transition={{
            repeat: isHovered ? Infinity : 0,
            repeatType: "mirror",
            ease: "easeInOut",
            duration: 2,
          }}
        />
      </svg>
    </div>
  );
}
